import { Component, OnInit, AfterViewInit, ViewChild, ViewChildren, ElementRef } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { ActivatedRoute, Router } from '@angular/router';
import { IAccount } from "../headerandnavigation/accounts/account";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs/Subject";
import { ManagedCardService } from "./managecards.service";
import { FormControlName, FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AddCardModel, CardDrawingEndPoint, PurchaseOption, CardAddress, CreateCard, TempCard, CreateCardModel } from "./managecards";
import { GenericValidator } from "../shared/generic-validator";
import { Observable } from "rxjs/Observable";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { ILoggedUser } from "../headerandnavigation/loggeduser/loggeduser";
import { IAuthToken } from "../auth.token";
import { LoaderService } from "../LoaderService";

declare var $: any;

@Component({
  templateUrl: "./managedcards.ordercards.component.html"
})
export class OrderCardsComponent implements OnInit, AfterViewInit {
  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  public pageTitle: string = 'Manage Cards';
  public managedCardsName: string = 'ordercards';

  public accessAccounts: IAccount[];
  public accessAcc: IAccount;
  public cardDrawingEndPointList: CardDrawingEndPoint[];
  public purchaseOptionList: PurchaseOption[];
  cardForm: FormGroup;
  addCardModel: AddCardModel;
  addressForm: FormGroup;
  cardAddress: CardAddress;
  loggedUser: ILoggedUser;
  public companyAddressList: CardAddress[];
  public createCardList: TempCard[] = [];
  result: any;
  // Use with the generic validation message class
  displayMessage: { [key: string]: string } = {};
  displayMessageForAddress: { [key: string]: string } = {};
  private validationMessages: { [key: string]: { [key: string]: string } };
  private validationMessagesForAddress: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;
  private genericValidatorForAddress: GenericValidator;
  showNoteResult: any;
  public showPin: boolean = true;
  public Purchase_Option: boolean = true;
  public showNote: boolean = false;
  public showAlternateDeliveryAddress: boolean = false;
  //public enableAddAnotherCardToOrder: boolean = false;
    public registrationmaxlength = 19;


  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private appCommonService: AppCommonService,
    public managedCardService: ManagedCardService,
    private route: ActivatedRoute,
    private router: Router,
    public headerAndNavigationService: HeaderAndNavigationService,
    public loaderService: LoaderService
  ) {
    this.appCommonService.pageContentAdditionalClass = "";
    this.appCommonService.pageName = this.pageTitle;
    this.validationMessages = {
      product: {
        required: 'Product is required.'
      },
      drawingPoint: {
        required: 'Drawing is required.'
      },
      //purchaseOption: {
      //  required: 'Purchase Option is required.'
      //},
      orderType: {
        required: 'Order Type is required.'
      },
      embossType: {
        required: 'Choose Name/Registration.'
      },
      embossValue: {
        required: 'Name/Registration is required.',
        pattern: "Name/Registration is not valid (Please enter Alpha and Numeric Characters Only)"
      }
      ,
      pin: {
        required: 'pin is required.',
        pattern: "pin is not valid"
      }
    };

    this.validationMessagesForAddress = {
      address1: {
        required: 'address1 is required.'
      },
      postToName: {
        required: 'postToName is required.'
      }
    };

    // Define an instance of the validator for use with this form, 
    // passing in this form's set of validation messages.
    this.genericValidator = new GenericValidator(this.validationMessages);
    this.genericValidatorForAddress = new GenericValidator(this.validationMessagesForAddress);
  }
  ngOnInit(): void {
    this.headerAndNavigationService.showhideNav(false, true);
    this.initAddCardSection();
    //debugger
    console.log(this.authService.getToken());
    this.showAlternateDeliveryAddress = this.authService.getToken().allowAlternateDeliveryAddress;
    this.result = this.authService.getToken().allowAlternateDeliveryAddress;
    //console.log(this.result);


    this.initAddressSection();

    this.showNote = this.authService.getToken().allowOrderNotes;
    this.showNoteResult = this.authService.getToken().allowOrderNotes;
    //$(document).ready(function () {
    //  var table = $('#ordercardsdatatable').DataTable({
    //    rowReorder: {
    //      selector: 'td:nth-child(2)'
    //    },
    //    responsive: true
    //  });
    //});
    
    //this.dtTrigger.next();
  }
 
  initAddressSection() {
    this.addressForm = this.fb.group({
      selectedAdd: [0],
      address1: ['', Validators.required],
      address2: '',
      address3: '',
      postCode: '',
      postToName: ['', Validators.required]
    });

    this.loggedUser = this.headerAndNavigationService.getLoggedUser();
   
    if (this.loggedUser == null) {
      this.headerAndNavigationService.RedirectToLogin();
    }
    this.initAddressSectionRelevantItems();
    //this.headerAndNavigationService.getLoggedUser()
    //  .subscribe(
    //  (user: ILoggedUser) => {
    //      this.loggedUser = user;
    //      this.initAddressSectionRelevantItems();
    //  },
    //  (error: any) => {
    //    this.headerAndNavigationService.showError("Logged user retrieval problem", <any>error);
    //    this.headerAndNavigationService.RedirectToLogin();
    //  }
    //);
  }

  initAddressSectionRelevantItems() {
    if (this.showAlternateDeliveryAddress == true) {
      this.managedCardService.getCompanyCardAddressListByCompanyId(this.loggedUser.companyId)
        .subscribe(
          (cardAddress: CardAddress[]) => {
            this.companyAddressList = cardAddress;
          },
          (error: any) => {
            this.managedCardService.showError("Address retrieval problem", <any>error);
          }
        );
    }
  }

  initAddCardSection() {
    this.cardForm = this.fb.group({
      product: ['', Validators.required],
      drawingPointId: ['', Validators.required],
      //purchaseOption: ['', Validators.required],
      purchaseOption: [''],
      orderType: ['', [Validators.required]],
      embossType: ['', Validators.required],
      embossValue: ['', Validators.required],
      //pin: ['', [Validators.required, Validators.pattern('^[0-9]{4}$')]],
      //pin: ['', [Validators.pattern('^[0-9]{4}$')]],
      pin: [''],
      note: ['']
    });
    this.initAddCardSectionRelevantItems();
  }

  initAddCardSectionRelevantItems() {
    this.accessAccounts = this.authService.getSelectedAccessAccounts();
    this.accessAcc = this.accessAccounts[0];
    this.cardForm.patchValue({
      product: this.accessAcc.id
    });
  
    this.loadProductReleventItemsIntCall(this.accessAcc);
    this.showPinCheck(this.accessAcc);
    this.showPurchase_Option(this.accessAcc);
  }

  ngAfterViewInit(): void {
    // Watch for the blur event from any input element on the form.
   // this.dtTrigger.next();
    let controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));

    // Merge the blur event observable with the valueChanges observable
    Observable.merge(this.cardForm.valueChanges, ...controlBlurs).debounceTime(500).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.cardForm);
    });

    // Merge the blur event observable with the valueChanges observable
    Observable.merge(this.addressForm.valueChanges, ...controlBlurs).debounceTime(500).subscribe(value => {
      this.displayMessageForAddress = this.genericValidatorForAddress.processMessages(this.addressForm);
    });
  }

  onProductSelected(event) {
    setTimeout(() => {
      this.loaderService.display(true);
    }, 0);
    this.accessAcc = this.accessAccounts.filter(x => x.id == event)[0];
    this.loadProductReleventItems(this.accessAcc);
    this.showPinCheck(this.accessAcc);
      this.showPurchase_Option(this.accessAcc);
      //registrationmaxlength
     
    setTimeout(() => {
      //this.loaderService.display(false);
    }, 1000);
  }

  showPurchase_Option(account: IAccount) {
    if (account != undefined) {
      var ledger = account.product
     
      if (ledger.indexOf('UK') >= 0 || ledger.indexOf('Fast') >= 0 || ledger.indexOf('Diesel') >= 0) {
        this.Purchase_Option = false;
      } else {
        this.Purchase_Option = true;
      }
    }
  }
  onDrawingSelected(event) {
    //setTimeout(() => {
    //  this.loaderService.display(true);
    //}, 0);
    this.loaderService.display(true);
    let productValue = this.cardForm.controls['product'].value;
    let getAcc = this.accessAccounts.filter(x => x.id == productValue)[0];
    let drawingPoint = this.cardDrawingEndPointList.filter(x => x.id == event)[0];
    this.showPinCheck(getAcc);
    this.loadPurchaseOptions(getAcc, drawingPoint);
    this.loadDefaultPin(getAcc, drawingPoint);
    setTimeout(() => {
      //this.loaderService.display(false);
    }, 1000);
  }

  onEmbossTypeSelected(value) {
    if (value == 'DRIVER_NAME') {
      this.cardForm.controls['embossValue'].setValidators([Validators.required, Validators.pattern("^[ A-Za-z0-9-']*$")]);
      this.cardForm.controls['embossValue'].patchValue(this.cardForm.controls['embossValue'].value);
      this.cardForm.controls['embossValue'].updateValueAndValidity;
    }
    else {
      this.cardForm.controls['embossValue'].setValidators([Validators.required, Validators.pattern("^[A-Za-z0-9-']*$")]);
      this.cardForm.controls['embossValue'].patchValue(this.cardForm.controls['embossValue'].value);
      this.cardForm.controls['embossValue'].updateValueAndValidity;
    }
  }

  showPinCheck(account: IAccount) {
    if (account != undefined) {
      var ledger = account.product
      //var ledger = account.ledger
      //if (ledger.includes("BP") || ledger.includes("Shell") || ledger.includes("Total")) {
      //    this.cardForm.controls['pin'].setValidators([Validators.required, Validators.pattern('^[0-9]{4}$')]);
      //    this.cardForm.controls['pin'].patchValue('');
      //    this.cardForm.controls['pin'].updateValueAndValidity;
      //    this.showPin = true;
      //}
      //else {
      //    this.cardForm.controls['pin'].setValidators([Validators.pattern('^[0-9]{4}$')]);
      //    this.cardForm.controls['pin'].patchValue('');
      //    this.cardForm.controls['pin'].updateValueAndValidity;
      //    this.showPin = false;
      //}

      //changed code 14-11-2018
      //if (ledger.indexOf('BP') >= 0 || ledger.indexOf('Shell') >= 0 || ledger.indexOf('Total') >= 0) {
      //    this.cardForm.controls['pin'].setValidators([Validators.pattern('^[0-9]{4}$')]);
      //    this.cardForm.controls['pin'].patchValue('');
      //    this.cardForm.controls['pin'].updateValueAndValidity;
      //    this.showPin = false;
      //}
      //else {
      //    this.cardForm.controls['pin'].setValidators([Validators.required, Validators.pattern('^[0-9]{4}$')]);
      //    this.cardForm.controls['pin'].patchValue('');
      //    this.cardForm.controls['pin'].updateValueAndValidity;
      //    this.showPin = true;
      //}

      //this.cardForm.controls['pin'].setValidators([Validators.pattern('^[0-9]{4}$')]);
      // this.cardForm.controls['pin'].patchValue('');
      // this.cardForm.controls['pin'].updateValueAndValidity;
      //this.showPin = true;

      if (ledger.indexOf('BP') >= 0 || ledger.indexOf('Shell') >= 0 || ledger.indexOf('Total') >= 0) {
        //this.cardForm.controls['pin'].setValidators([Validators.required, Validators.pattern('^[0-9]{4}$')]);
        this.cardForm.controls['pin'].setValidators([Validators.pattern('^[0-9]{4}$')]);
        this.cardForm.controls['pin'].patchValue('');
        this.cardForm.controls['pin'].updateValueAndValidity;
        this.showPin = true;
      }
      else {
        this.cardForm.controls['pin'].setValidators([Validators.pattern('^[0-9]{4}$')]);
        this.cardForm.controls['pin'].patchValue('');
        this.cardForm.controls['pin'].updateValueAndValidity;
        this.showPin = false;
        }

        //set max length for registration - registrationmaxlength
        this.cardForm.controls['embossValue'].patchValue('');
        if (ledger.indexOf('BP') >= 0 ) {           
            this.registrationmaxlength = 14;
        } else if (ledger.indexOf('Shell') >= 0) {
            this.registrationmaxlength = 16;
        }
        else {
            this.registrationmaxlength = 19;
        }

    }

  }

  loadProductReleventItems(account: IAccount) {
    if (account != null) {
      this.managedCardService.getDrawingPointsByAccountId(account.id)
        .subscribe(
          (cardDrawingEndPoints: CardDrawingEndPoint[]) => {
            if (cardDrawingEndPoints.length > 0) {
              cardDrawingEndPoints = cardDrawingEndPoints.sort((a: CardDrawingEndPoint, b: CardDrawingEndPoint): number => {
                return (a.number === b.number) ? 0 : (a.number < b.number) ? -1 : 1;
              });
              this.cardDrawingEndPointList = cardDrawingEndPoints;
              let defaultDrawingPointList = cardDrawingEndPoints.filter(d => d.isDefaultDrawingPoint == true);
             
              let defaultDrawingPoint: CardDrawingEndPoint = null;
              if (defaultDrawingPointList.length > 0) {
                defaultDrawingPoint = defaultDrawingPointList[0];
              }
              else {
                defaultDrawingPoint = this.cardDrawingEndPointList[0];
              }

              this.cardForm.patchValue({
                drawingPointId: defaultDrawingPoint.id
              });
              this.loadDefaultPin(account, defaultDrawingPoint);
            }
            else {
              this.cardDrawingEndPointList = cardDrawingEndPoints;
              this.cardForm.patchValue({
                drawingPointId: ''
              });
            }
            //this.loaderService.display(false);
          },
          (error: any) => {
            //this.loaderService.display(false);
            this.managedCardService.showError("Card end points retrieval problem", <any>error)
          }
        );
    }
  }

  loadProductReleventItemsIntCall(account: IAccount) {
    if (account != null) {
      this.loaderService.display(true);
      this.managedCardService.getDrawingPointsByAccountId(account.id)
        .subscribe(
          (cardDrawingEndPoints: CardDrawingEndPoint[]) => {
            if (cardDrawingEndPoints.length > 0) {
              cardDrawingEndPoints = cardDrawingEndPoints.sort((a: CardDrawingEndPoint, b: CardDrawingEndPoint): number => {
                return (a.number === b.number) ? 0 : (a.number < b.number) ? -1 : 1;
              });
              this.cardDrawingEndPointList = cardDrawingEndPoints;
              let defaultDrawingPointList = cardDrawingEndPoints.filter(d => d.isDefaultDrawingPoint == true);
              let defaultDrawingPoint: CardDrawingEndPoint = null;
              
              if (defaultDrawingPointList.length > 0) {
                defaultDrawingPoint = defaultDrawingPointList[0];
              }
              else {
                defaultDrawingPoint = this.cardDrawingEndPointList[0];
              }

              this.cardForm.patchValue({
                drawingPointId: defaultDrawingPoint.id
              });
              this.loadDefaultPin(account, defaultDrawingPoint);
              //setTimeout(() => {
              //  this.loaderService.display(false);
              //},1000);
            }
            else {
              this.cardDrawingEndPointList = cardDrawingEndPoints;
              this.cardForm.patchValue({
                drawingPointId: ''
              });
              //setTimeout(() => {
              //  this.loaderService.display(false);
              //}, 1000);
            }
          
            //this.loaderService.display(false);
          },
          (error: any) => {
            this.loaderService.display(false);
            this.managedCardService.showError("Card end points retrieval problem", <any>error)
          }
        );
    }
  }
  loadPurchaseOptions(account: IAccount, cardDrawingEndPoint: CardDrawingEndPoint) {
    this.loaderService.display(true);
    if (account != null) {
      this.managedCardService.getPurchaseOptionByLedgerNumber(account.product)
        .subscribe(
          (purchaseOptions: PurchaseOption[]) => {
            this.purchaseOptionList = purchaseOptions;
            if (purchaseOptions.length > 0) {
              let defaultPurchaseOption: PurchaseOption = null;
              if (cardDrawingEndPoint.defaultPurchaseOption) {
                this.cardForm.patchValue({
                  purchaseOption: cardDrawingEndPoint.defaultPurchaseOption
                });
              }
              else {
                this.cardForm.patchValue({
                  purchaseOption: this.purchaseOptionList[0].name
                });
              }
            }
            else {
              this.cardForm.patchValue({
                purchaseOption: ''
              });
            }
            this.loaderService.display(false);
          },
          (error: any) => {
            this.loaderService.display(false);
            this.managedCardService.showError("Purchase option retrieval problem", <any>error)
          }
        );
    }
  }

  loadDefaultPin(account: IAccount, cardDrawingEndPoint: CardDrawingEndPoint) {
    if (account != null && cardDrawingEndPoint != null) {
      this.cardForm.patchValue({
        pin: cardDrawingEndPoint.defaultPinNumber
      });
    }
  }

  saveCard(): void {
    if (this.cardForm.valid) {
     
      let addCardInfo = Object.assign({}, this.cardForm.value);

      if (addCardInfo.pin != undefined && addCardInfo.pin == "0000") {
        this.managedCardService.showError("Invalid Pin", <any>"Invalid Pin");
        this.loaderService.display(false);
      }
      
     else if (addCardInfo.pin != undefined && addCardInfo.pin == "1234") {
        this.managedCardService.showError("Invalid Pin", <any>"Invalid Pin");
        this.loaderService.display(false);
      }
      else {

        let newCard: TempCard = new TempCard();
        newCard.product = addCardInfo.product;
        newCard.productText = this.accessAccounts.filter(x => x.id == addCardInfo.product)[0].product;
        newCard.drawPointText = this.cardDrawingEndPointList.filter(x => x.id == addCardInfo.drawingPointId)[0].number;
        newCard.drawingPointId = addCardInfo.drawingPointId;
        if (this.Purchase_Option == true) {
          newCard.purchaseOption = addCardInfo.purchaseOption;
        } else {
          newCard.purchaseOption = "";
        }
        newCard.orderType = addCardInfo.orderType;
        newCard.orderTypeText = (addCardInfo.orderType == 'ADDITIONAL') ? "Additinal Card" : "Replacement Card";
        newCard.embossType = addCardInfo.embossType;
        newCard.embossValue = addCardInfo.embossValue.toUpperCase();
        newCard.pin = addCardInfo.pin;
        newCard.note = addCardInfo.note;
        if (this.showAlternateDeliveryAddress == true) {
          let addressInfo = Object.assign({}, this.addressForm.value);
          newCard.cardAddress1 = addressInfo.address1;
          newCard.cardAddress2 = addressInfo.address2;
          newCard.cardAddress3 = addressInfo.address3;
          newCard.cardAddressPostCode = addressInfo.postCode;
          newCard.cardAddressPostToName = addressInfo.postToName;
        }
        else {
          newCard.cardAddress1 = '';
          newCard.cardAddressPostToName = '';
        }
        this.createCardList.push(newCard);
        this.loaderService.display(true);
        setTimeout(() => {

          this.afterSaveData();
        }, 100);
        this.loaderService.display(false);
        console.log(this.createCardList)

      }
      //this.enableAddAnotherCardToOrder = true;
    
    }
  }
  afterSaveData() {
    $('#ordercardsdatatable').DataTable().destroy();
   
      var atthis = this;
      $('#ordercardsdatatable').DataTable({
        dom:'tp',// '<"top"i<"clear">>rt<"bottom"i<"clear">>',
        responsive: true,
        info: false,
        iDisplayLength: 10,
        ordering: false,
        data: this.createCardList,
        columns: [
          { data: 'productText' },
          { data: 'drawPointText' },
          { data: 'purchaseOption' },
          { data: 'orderTypeText' },
          { data: 'embossValue' },
          { data: 'pin' },
          { data: 'cardAddressPostToName' },
          { data: 'cardAddress1' },
          {
            data: '',
            orderable: false,
            searchable: false,
            render: function (data, type, row, meta) { // render event defines the markup of the cell text 

              var a = '<i class="smcirlce glyphicon glyphicon-remove AMC"></i>'; // row object contains the row data

              return a;
            }
          }
        ],
        rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)

          $('td', nRow).unbind('click');
          $('td .AMC', nRow).bind('click', function () {
            //console.log(JSON.stringify(aData));
            //console.log(nRow);
            atthis.onRemoveCreateCard(iDisplayIndex);
            atthis.afterSaveData();
          });
          return nRow;
        }
      }).columns.adjust()
        .responsive.recalc();
      //for (var i = 0; i < this.createCardList.length; i++) {
      //  $("#ordercardsdatatable tbody").append("<tr><td>" + this.createCardList[i].productText + "</td><td>" + this.createCardList[i].drawPointText + "</td>"+
      //    "<td> " + this.createCardList[i].purchaseOption + "</td>"+
      //    "<td> " + this.createCardList[i].orderTypeText + "</td>" +
      //    "<td> " + this.createCardList[i].embossValue + "</td>"+
      //    "<td> " + this.createCardList[i].pin + "</td>"+
      //    "<td> " + this.createCardList[i].cardAddressPostToName + "</td>"+
      //    "<td> " + this.createCardList[i].cardAddress1 + "</td>"+
      //    "<td (click)='onRemoveCreateCard("+i+ ")'> <i class='smcirlce glyphicon glyphicon - remove'></i></td>< /tr>");
      //}

  }
  saveAddress(): void {
    if (this.addressForm.valid) {
      let ca = Object.assign({}, this.cardAddress, this.addressForm.value);
      this.managedCardService.createCardAddress(ca, this.loggedUser.companyId)
        .subscribe(
          (cardAddress: CardAddress) => {
            this.managedCardService.showSuccess("Save Address", "Address saved successfully.")
            this.managedCardService.getCompanyCardAddressListByCompanyId(this.loggedUser.companyId)
              .subscribe(
                (cardAddressList: CardAddress[]) => {
                  this.companyAddressList = cardAddressList;
                  this.addressForm.patchValue({
                    selectedAdd: cardAddressList[(cardAddressList.length - 1)].id
                  });
                },
                (error: any) => {
                  this.managedCardService.showError("Address retrieval problem", <any>error)
                }
              );
          },
          (error: any) => {
            this.managedCardService.showError("Save Address problem", <any>error)
          }
        );
    }
  }

  onAddressSelected(event) {
    if (event != 0) {
      var address: CardAddress = this.companyAddressList.filter(x => x.id == event)[0];
      if (address != null) {
        this.addressForm.patchValue({
          address1: address.address1,
          address2: address.address2,
          address3: address.address3,
          postCode: address.postCode,
          postToName: address.postToName
        });
      }
    }
    else {
      this.addressForm.patchValue({
        address1: '',
        address2: '',
        address3: '',
        postCode: '',
        postToName: ''
      });
    }
  }

  onDeleteAddress() {
    var addressSelected = $("#selectedAddId").val();
    if (addressSelected != 0) {
      var address: CardAddress = this.companyAddressList.filter(x => x.id == addressSelected)[0];
      this.managedCardService.deleteCardAddress(address, this.loggedUser.companyId)
        .subscribe(
          (cardAddress: CardAddress) => {
            this.managedCardService.showSuccess("Delete Address", "Address deleted successfully.")
            this.addressForm.reset();
            this.initAddressSectionRelevantItems();
          },
          (error: any) => {
            this.managedCardService.showError("Delete Address problem", <any>error)
          }
        );
    }
  }

  onAddAnotherCard() {
    this.addressForm.reset();
    this.cardForm.reset();
    this.initAddressSectionRelevantItems();
    this.initAddCardSectionRelevantItems();
    //this.enableAddAnotherCardToOrder = false;
  }

  onRemoveCreateCard(index: number) {
    this.createCardList.splice(index, 1);
  }

  onOrderCards() {
    if (this.createCardList.length > 0) {
      let orderCards: CreateCardModel = new CreateCardModel();
      orderCards.cardRequests = [];
      this.createCardList.forEach(function (value) {
        let nCard: CreateCard = new CreateCard();
        nCard.cardAddress1 = value.cardAddress1;
        nCard.cardAddress2 = value.cardAddress2;
        nCard.cardAddress3 = value.cardAddress3;
        nCard.cardAddressPostCode = value.cardAddressPostCode;
        nCard.cardAddressPostToName = value.cardAddressPostToName;
        nCard.drawingPointId = value.drawingPointId;
        nCard.embossType = value.embossType;
        nCard.embossValue = value.embossValue;
        nCard.note = value.note;
        nCard.orderType = value.orderType;
        nCard.pin = value.pin;
        nCard.purchaseOption = value.purchaseOption;
        orderCards.cardRequests.push(nCard);
      });
      $('#PlaceOrderButton').prop('disabled', true);
      this.managedCardService.createCards(orderCards)
        .subscribe(
          (createCardModel: CreateCardModel) => {
            this.onAddAnotherCard();
            this.createCardList = [];
            this.managedCardService.showSuccess("Order Card", "Cards are successfully ordered.")
            $('#PlaceOrderButton').prop('disabled', false);
          },
          (error: any) => {
            let anyError = "EmbossValue must not exceed 16 characters for ledger 6."
            // var url = 'EmbossValue must not exceed 16 characters for ledger 6.4';
            $('#PlaceOrderButton').prop('disabled', false);
            for (let i = 0; i < error.FieldErrors.length; i++) {
              //console.log(error.FieldErrors[i]);
              if (error.FieldErrors[i].Message.includes("EmbossValue")) {
                error.FieldErrors[i].Message = error.FieldErrors[i].Message.split('for')[0];
                this.managedCardService.showError("Order Card problem", <any>error)

              }
              else {
                this.managedCardService.showError("Order Card problem", <any>error)
              }
            }

            // anyError.split("characters",
            // this.managedCardService.showError("Order Card problem", <any>error)
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/managecards/managedcards.ordercards.component.ts